var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GlobalWindow',{attrs:{"visible":_vm.visible,"confirm-working":_vm.isWorking,"width":"700px","title":"选择异常推送用户"},on:{"update:visible":function($event){_vm.visible=$event},"confirm":_vm.confirm}},[_c('el-transfer',{attrs:{"width":"500px","filterable":"","titles":['未选择的用户', '已选择的用户'],"props":{
      key: 'id',
      label: 'realname'
    },"data":_vm.roles},model:{value:(_vm.selectedIds),callback:function ($$v) {_vm.selectedIds=$$v},expression:"selectedIds"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }